module.exports = __webpack_public_path__ + "media/images/cloud-computing-ceb90fbb633a111fa4a12ae45d862fd1.png";